module.exports = __webpack_public_path__ + "img/sendMessageIcon.b68b6421.svg";